<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Export {{formTitle}}</h3>
</div>
<div class="modal-body">
    <p>What would you like to name the file?</p>
    <input class="form-control" type="text" id ="filename" name="filename" [(ngModel)]="filename" [required]="filename == null || filename === ''"/>
</div>
<div class="modal-footer ">
    <button type="button" class="btn btn-success" (click)="export()" [disabled]="filename == null || filename === ''">Export</button>
    <button type="button" class="btn btn-outline-primary" (click)="closeModal()">Cancel</button>
</div>